<template>
  <form @submit.prevent="submit" :novalidate="true">
    <b-card>
      <div class="row">
        <div class="col-1 ms-auto" v-bind:class="{ inlineSpinner: isBusy }"></div>
      </div>

      <div v-if="localUserProfile">
        <b-form-group :label-cols-sm="2" :label="$t('Webportal.Name')" label-class="fw-bold"
                      class="g-3 mb-3"
                      :disabled="true">
          <b-row class="g-3">
            <b-form-group class="col-auto">
              <b-form-input v-model="localUserProfile.FirstName"></b-form-input>
            </b-form-group>
            <b-form-group class="col-auto">
              <b-form-input v-model="localUserProfile.LastName"></b-form-input>
            </b-form-group>
          </b-row>
        </b-form-group>

        <b-form-group :label-cols-sm="2" :label="$t('Webportal.EmailAddress')"
                      class="g-3 my-3"
                      label-class="fw-bold"
                      :disabled="true">
          <b-form-input v-model="localUserProfile.Email"></b-form-input>
        </b-form-group>
      </div>

      <template v-slot:footer>
        <div class="float-end">
          <button @click.prevent="cancel" class="btn btn-secondary" :disabled="!isFormChanged || isBusy">
            <font-awesome-icon :icon="['far', 'ban']" /> {{ $t('Webportal.Cancel') }}
          </button>
          <button type="submit" class="btn btn-primary" :disabled="!isFormChanged || !isFormValid || isBusy">
            <font-awesome-icon :icon="['far', 'dot-circle']" /> {{ $t('Webportal.Save') }}
          </button>
        </div>
      </template>
    </b-card>
  </form>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import AuthenticationService from '@/services/AuthenticationService';

import useVuelidate from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';

export default {
  name: "UserProfile",

  mixins: [ AppConfig ],

  setup() {
    return { v$: useVuelidate() };
  },

  data () {
    return {
      profileSettings: null,

      isBusy: false
    }
  },

  mounted() {
    this.initializeTheme();
  },

  computed: {
    isFormChanged() {
      return this.v$.$anyDirty;
    },

    isFormValid() {
      return !this.v$.$error || this.v$.$anyDirty;
    },

    localUserProfile: function() {
      return AuthenticationService.localUserProfile;
    },
  },

  activated() {
    this.getProfileSettings();
  },

  beforeRouteLeave (to, from, next) {
    this.$emit('unsavedChanges', this.isFormChanged, next);
  },

  methods: {
    getProfileSettings() {
      // AdministrationService.getProfileSettings()
      //   .then(response => {
      //     this.isBusy = false;

      //     this.profileSettings = response.data ? response.data[0] : null;
      //     this.v$.$reset();
      //   });
    },

    cancel() {
      this.$emit('unsavedChanges', this.isFormChanged, result => {
        if (result !== false) this.getProfileSettings();
      });
    },

    submit() {
      this.isBusy = true;

      // AdministrationService.setProfileSettings(this.profileSettings)
      //   .then(response => {
      //     this.isBusy = false;
      //     this.v$.$reset();
      //   })
      //   .catch(_ => { this.isBusy = false; } );
    }
  }
}
</script>
